import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ISiteMaintenanceBanner {
    isEnabled: boolean;
    bannerMessage: string;
    bannerBackgroundColor: string;
    bannerTextColor: string;
    bannerFontSize: string;
    bannerFontWeight: string;
    bannerTextAlign: string;
    bannerPadding: string;
    startDateTime: string;
    endDateTime: string;
    selectedTimezone: string;
    disableButtons: boolean;
    disableNavLinks: boolean;
    disabledTooltip: string;
}

export const IS_ENABLED = false;
export const BANNER_MESSAGE = "This site is currently undergoing scheduled maintenance. Please try again later.";
export const BANNER_BACKGROUND_COLOR = "#f8d7da";
export const BANNER_TEXT_COLOR = "#721c24";
export const START_DATE_TIME = "";
export const END_DATE_TIME = "";
export const SELECTED_TIMEZONE = "America/Chicago";
export const BANNER_FONT_SIZE = "15px";
export const BANNER_FONT_WEIGHT = "500";
export const BANNER_TEXT_ALIGN = "center";
export const BANNER_PADDING = "12px 24px";
export const DISABLE_BUTTONS = true;
export const DISABLE_NAV_LINKS = true;
export const DISABLED_TOOLTIP = "Payments are temporarily unavailable during maintenance.";

export const TIMEZONE_OPTIONS = [
    { label: "Eastern (ET)", value: "America/New_York" },
    { label: "Central (CT)", value: "America/Chicago" },
    { label: "Mountain (MT)", value: "America/Denver" },
    { label: "Pacific (PT)", value: "America/Los_Angeles" },
    { label: "Alaska (AKT)", value: "America/Anchorage" },
    { label: "Hawaii (HT)", value: "Pacific/Honolulu" },
    { label: "UTC", value: "UTC" },
];

export function coerceBool(value: boolean | string | undefined, fallback: boolean): boolean {
    if (value === undefined || value === null) return fallback;
    if (typeof value === "boolean") return value;
    return value === "true";
}

const SiteMaintenanceBanner = ({
    isEnabled,
    bannerMessage,
    bannerBackgroundColor,
    bannerTextColor,
    bannerFontSize,
    bannerFontWeight,
    bannerTextAlign,
    bannerPadding,
    startDateTime,
    endDateTime,
    selectedTimezone,
    disableButtons,
    disableNavLinks,
}: ISiteMaintenanceBanner) => {
    const _isEnabled = coerceBool(isEnabled, IS_ENABLED);
    const _disableButtons = coerceBool(disableButtons, DISABLE_BUTTONS);
    const _disableNavLinks = coerceBool(disableNavLinks, DISABLE_NAV_LINKS);
    const tzLabel = TIMEZONE_OPTIONS.find(t => t.value === selectedTimezone)?.label ?? selectedTimezone;

    const disabledItems = [
        _disableButtons && "buttons",
        _disableNavLinks && "nav links",
    ].filter(Boolean).join(", ") || "nothing";

    return (
        <div style={{
            backgroundColor: bannerBackgroundColor || BANNER_BACKGROUND_COLOR,
            color: bannerTextColor || BANNER_TEXT_COLOR,
            padding: bannerPadding || BANNER_PADDING,
            fontSize: bannerFontSize || BANNER_FONT_SIZE,
            fontWeight: (bannerFontWeight || BANNER_FONT_WEIGHT) as any,
            textAlign: (bannerTextAlign || BANNER_TEXT_ALIGN) as any,
            border: `1px solid ${(bannerTextColor || BANNER_TEXT_COLOR)}33`,
            lineHeight: 1.5,
            width: "100%",
            boxSizing: "border-box",
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#FFC107", fontSize: "18px", marginRight: "10px", flexShrink: 0 }} />
                {bannerMessage || BANNER_MESSAGE}
            </div>
            <div style={{ fontSize: "12px", marginTop: "6px", opacity: 0.75, textAlign: "left" }}>
                <strong>Status:</strong> {_isEnabled ? "Enabled (manual)" : "Disabled (manual)"}
                {startDateTime && endDateTime
                    ? ` · Scheduled ${startDateTime} – ${endDateTime} (${tzLabel})`
                    : " · No schedule set"
                }
                {" · "}
                <strong>Will disable:</strong> {disabledItems}
            </div>
        </div>
    );
};

export default SiteMaintenanceBanner;